import {
  getWellsForMappingForProject,
  isMultipartSetupOfSpecificType,
  useAppDispatch,
} from '@core/core/store'
import type { MarkerSetupType } from '@core/core/types'
import type { FC } from 'react'
import { useEffect } from 'react'

import {
  MarkersLoading,
  MarkersMapping,
  MarkersSetup,
  useMarkerLoader,
  useMarkerParser,
} from '../MarkersImport'
import type { StepComponentProps } from '../types'
import { useNarrowType } from './useNarrowType'

export const StepMarkerComponent: FC<StepComponentProps> = ({
  file,
  activeStep,
  updateFileConfig,
  removeOpenFiles,
}) => {
  // Подгрузка списка скважин проекта для маппинга при активации мастера импорта
  const dispatch = useAppDispatch()
  const projectId = file.uploadedFile?.projectId
  useEffect(() => {
    if (projectId !== undefined && projectId !== '') {
      dispatch(getWellsForMappingForProject(projectId))
    }
  }, [projectId])

  const rightType = useNarrowType(file.uploadedFile, file.uploadedFile?.setupContent)

  const parsedData = useMarkerParser(
    file.file,
    activeStep,
    rightType?.settings,
    rightType?.uploadedFile?.mappedEntities,
  )
  useMarkerLoader(rightType?.uploadedFile, parsedData.result, removeOpenFiles)

  if (!rightType || !rightType.uploadedFile) {
    return null
  }

  switch (activeStep) {
    case 'setup': {
      return (
        <MarkersSetup
          file={rightType.uploadedFile}
          settings={rightType.settings}
          parsedData={parsedData}
          updateFileConfig={updateFileConfig}
        />
      )
    }
    case 'mapping': {
      return (
        <MarkersMapping
          file={rightType.uploadedFile}
          parsedData={parsedData}
          settings={rightType.settings}
        />
      )
    }
    case 'loading': {
      return <MarkersLoading file={rightType.uploadedFile} />
    }
    default: {
      return null
    }
  }
}
